import React, { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import ResourcesDetails from './ResourcesDetails'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { ResourceBreadCrum } from '../core/_constants'
import { getResourcesDetailData } from '../core/_requests'
import { toast } from 'react-toastify'
import { useAuth } from '../../../../app/modules/auth'

// interface RouteParams {
//   resourceId: string
// }

const ResourceDetail: React.FC = () => {
  const { formatMessage } = useIntl()
  const { resourceId } = useParams()
  const [ResourcesDetailData, setResourcesDetailData] = useState<any>([])
  const { companyId } = useAuth()

  const { ResourcesDocBreadCrum } = ResourceBreadCrum()
  console.log('resourceIIID', resourceId)
  const [loading, setLoading] = useState(true)
  const getResourcesDetail = useCallback(async () => {
    try {
      setLoading(true)
      const {
        data: { success, data, errors },
      } = await getResourcesDetailData(resourceId!, companyId!)
      if (success) {
        console.log('resource detail data', data)
        setResourcesDetailData(data)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }, [resourceId, companyId, formatMessage])

  useEffect(() => {
    getResourcesDetail()
  }, [getResourcesDetail])

  return (
    <>
      <PageTitle breadcrumbs={ResourcesDocBreadCrum} description={formatMessage({ id: 'Documents' })}>
        {formatMessage({ id: 'Resources' })}
      </PageTitle>

      <div className='my-6'>
        {ResourcesDetailData && (
          <div className='p-4 bg-white rounded-3' style={{ height: 'auto' }}>
            <ResourcesDetails resourceData={ResourcesDetailData} loading={loading} />
          </div>
        )}
        <div className='mt-4'>
        </div>
      </div>
    </>
  )
}

export default ResourceDetail
